import React, { useState, useEffect } from "react";
import "./Classement.css";
import { fetchRanking } from "../../ServiceApi";
import LoadingSpinner from "../LoadingSpinner/LoadingSpinner";

const Classement = ({ competitionId, pouleId = 1, limitedWidth = false, showTitle = true }) => {
    const [classementData, setClassementData] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const loadRanking = async () => {
            try {
                console.log("pouleId classement", pouleId);
                const data = await fetchRanking(competitionId, pouleId);
                setClassementData(data);
            } catch (error) {
                console.error("Erreur lors du chargement du classement :", error);
            } finally {
                setLoading(false);
            }
        };

        loadRanking();
    }, [competitionId]);

    if (loading) return <LoadingSpinner />;

    return (
        <section
            className={`classement-section ${limitedWidth ? "classement-wrapper-limited" : ""} ${
                !showTitle ? "no-title" : ""
            }`}
        >
            {/* Rendre le titre uniquement si showTitle est true */}
            {showTitle && (
                <h2 className="classement-title">Classement Actuel</h2>
            )}
            <div className="classement-table-wrapper">
                <table className="classement-table">
                    <thead>
                        <tr>
                            <th className="col-position">Position</th>
                            <th className="col-team">Équipe</th>
                            <th className="col-points" data-abbr="P">Points</th>
                            <th className="col-played" data-abbr="J">Joués</th>
                            <th className="col-wins" data-abbr="V">Victoires</th>
                            <th className="col-defeats" data-abbr="D">Défaites</th>
                            <th className="col-difference" data-abbr="Diff">Différence</th>
                        </tr>
                    </thead>
                    <tbody>
                        {classementData.length > 0 ? (
                            classementData.map((row) => {
                                const isMyTeam = row.equipe.short_name.toUpperCase() === "NANTES DOULON B.";
                                return (
                                    <tr key={row["@id"]} className={isMyTeam ? "highlight-my-team" : ""}>
                                        <td>{row.rank}</td>
                                        <td>{row.equipe.short_name}</td>
                                        <td>{row.point_count}</td>
                                        <td>{row.total_games_count}</td>
                                        <td>{row.won_games_count}</td>
                                        <td>{row.lost_games_count}</td>
                                        <td>{row.goals_diff}</td>
                                    </tr>
                                );
                            })
                        ) : (
                            <tr>
                                <td colSpan="7" style={{ textAlign: "center" }}>
                                    Aucun classement disponible
                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>
        </section>
    );

};

export default Classement;
